export const tableConfig = {
    name: 'visitTransfer',
    fields: [
        {
            label: '转办人',
            prop: 'ownerName',
            value: 'ownerName',
            name: '转办人',
            type: 'advance',
            mustFill: true,
            advanceConfig: [
                { 'prop': 'esusUserNameCn', 'value': '姓名' },
                { 'prop': 'esusLoginName', 'value': '美信号' }
            ],
            tableConfig: [
                { 'prop': 'esusLoginName', 'value': '美信号' },
                { 'prop': 'esusUserNameCn', 'value': '姓名' },
                { 'prop': 'escoCompanyNameCn', 'value': '部门' }
            ],
            prefix: '/api-lcrm',
            advanceUrl: '/crmUser/page',
            cbParams: ['esusUserNameCn#ownerName', 'esusLoginName#ownerCode', 'escoCompanyNameCn#departName', 'departmentCode#departCode'],
            visible: true,
            rule: [
                { required: true, message: '转办人不能为空,请弹窗选择', trigger: 'change' }
            ],
            beforeRequest: (params) => {
                const inputKey = (params.esusUserNameCn ? params.esusUserNameCn : (params.esusLoginName ? params.esusLoginName : '')).trim();
                const reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g');
                if (reg.test(inputKey)) {
                    params.esusUserNameCn = inputKey;
                    params.esusLoginName = null;
                } else {
                    params.esusLoginName = inputKey;
                    params.esusUserNameCn = null;
                }
                return params;
            },
            dialogCloseTips: true
        }
    ],
    height: 325
};
